/**
 * Delivery speed of assignment - prioritization param for OPS.
 * Default is STANDARD.
 * FAST is applicable for subscribed users (might be implemented as purchasable add-on in the future).
 */
export enum AssignmentDeliverySpeed {
  FAST = 'FAST',
  STANDARD = 'STANDARD'
}
